import React from "react";


export function ArticleNotFound(props) {
    return (
        <div className="help-centre-item help-centre-item--not-found">
            <div className="notification notification--info notification--left">
                <div className="notification__content">
                    <h5 className="font-normal">{props.data.title}</h5>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: props.data.content
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
}